<template>
  <div>
    <page-header />
    <box class="content">
      <div slot="buttons">
        <button
          type="button"
          class="btn btn-danger btn-sm"
          title="Excluir certificado"
          @click.prevent="modalConfirmarSenha = true"
          :disabled="!certificado.status"
          v-apply-rules="permissions"
        >
          <i class="fa fa-download"></i> Excluir
        </button>
        <button
          type="button"
          class="btn btn-warning btn-sm"
          title="Download do certificado"
          @click.prevent="download"
          :disabled="!certificado.status"
        >
          <i class="fa fa-download"></i> Download
        </button>
      </div>
      <div slot="body">
        <div class="row" v-if="!certificado.status">
          <div class="col-sm-12">
            <div class="callout callout-info">
              <h4>Atenção!</h4>
              <p>A empresa não possui certificado importado.</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2">
            <div class="form-group" :class="{ 'has-error': $v.certificado.senha.$invalid }">
              <label for="senha">Senha:</label>
              <input type="text" class="form-control" v-model="certificado.senha" />
              <p class="help-block" v-if="!$v.certificado.senha.required">
                Esse campo é obrigatório.
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group" :class="{ 'has-error': $v.certificado.arquivos.$invalid }">
              <label for="arquivo">Arquivo:</label>
              <uploader
                id="arquivo"
                :multiple="false"
                :min-length="1"
                :max-length="1"
                placeholder="Selecionar arquivo..."
                :accept="['.pfx']"
                @on-upload="onUpload"
                @on-select="onSelect"
                :disabled="$v.certificado.$invalid"
              />
              <!-- <p class="help-block" v-if="!$v.certificado.arquivos.required">Você deve selecionar um arquivo válido.</p> -->
            </div>
          </div>
        </div>
        <div class="row" v-if="certificado.status">
          <div class="col-sm-12">
            <div
              class="col-sm-4 media alert"
              :class="{
                'alert-success': certificado.diasExpirar > 40,
                'alert-warning': certificado.diasExpirar <= 40,
                'alert-danger':
                  certificado.diasExpirar <= 10 || certificado.diasExpirar === 'VENCIDO'
              }"
              style="border: 1px solid #ccc; margin: 0;"
            >
              <div class="media-left media-middle">
                <i
                  class="fa fa-3x"
                  :class="{
                    'fa-check': certificado.diasExpirar > 40,
                    'fa-exclamation-triangle': certificado.diasExpirar <= 40,
                    'fa-times':
                      certificado.diasExpirar <= 10 || certificado.diasExpirar === 'VENCIDO'
                  }"
                />
              </div>
              <div class="media-body">
                <h4 class="media-heading">
                  {{
                    usuarioSelecionado.departament.idDepartamento === 2
                      ? 'Meu Certificado'
                      : 'Informações'
                  }}
                </h4>
                <dd>Vencimento: <i class="fa fa-calendar" /> {{ certificado.validade | date }}</dd>
                <dd>
                  Dias restantes: <i class="fa fa-clock-o" />
                  {{
                    certificado.diasExpirar === 'VENCIDO'
                      ? 'Vencido'
                      : `${certificado.diasExpirar} dias`
                  }}
                </dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </box>

    <confirmar-senha
      v-if="modalConfirmarSenha"
      @on-cancel="modalConfirmarSenha = false"
      @on-success="remove"
    />
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'
import Box from '../../components/Box.vue'
import Uploader from '../../components/Uploader.vue'
import { required, minLength } from 'vuelidate/lib/validators'
import CertificadoService from '../../services/CertificadoService'
import UtilService from '../../services/UtilService'
import InputSenha from '../../components/Inputs/InputSenha.vue'
import ConfirmarSenha from '../../components/ConfirmarSenha.vue'
import Permissions from '../../models/Permissions'

export default {
  data() {
    return {
      certificado: {
        senha: '',
        arquivos: []
      },
      modalConfirmarSenha: false,
      permissions: [Permissions.ADMINISTRADOR, Permissions.GESTOR]
    }
  },

  mounted() {
    this.carregar()
  },

  methods: {
    async onUpload() {
      try {
        this.certificado.empresa = this.empresaSelecionada
        const data = await CertificadoService.insert(
          this.certificado,
          this.empresaSelecionada.cnpj,
          this.usuarioSelecionado
        )
        this.certificado.senha = ''
        this.certificado.arquivos = []
        this.$bus.$emit('uploader:reset')
        this.carregar()
        this.$messages.success().toast(data.body.message)
      } catch (e) {
        this.$messages.error(e.message || e.data.err).toast(e.data.message)
        console.error(e)
      }
    },

    onSelect(arquivos) {
      this.certificado.arquivos = arquivos
    },

    async download() {
      try {
        const data = await CertificadoService.download(this.empresaSelecionada.cnpj)
        UtilService.download(
          data.body,
          this.certificado.empresa.fantasia.replace(/\s/g, '_') + '.pfx'
        )
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possivel completar o download.')
      }
    },

    async carregar() {
      try {
        const data = await CertificadoService.retrieve(this.empresaSelecionada.cnpj)
        this.certificado = data.body
      } catch (e) {
        console.error(e)
        if (e.data.message.includes('Nenhum certificado encontrado')) {
          this.$messages
            .warning(e.message || e.data.message)
            .toast('Não foi possível buscar os dados do certificado')
          return
        }
        this.$messages.error(e.message || e.data.message).toast(e.message || e.data.message)
      }
    },

    async remove() {
      try {
        this.modalConfirmarSenha = false
        const data = await CertificadoService.remove(this.empresaSelecionada.cnpj)
        this.certificado = { senha: '', arquivos: [] }
        this.$messages.success().toast(data.body.message)
      } catch (e) {
        this.$messages.error(e.message || e.data.message).toast(e.message || e.data.message)
        console.error(e)
      }
    }
  },

  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    },

    usuarioSelecionado() {
      return this.$store.getters.getUser
    }
  },

  watch: {
    empresaSelecionada() {
      // this.carregar()
    }
  },

  validations() {
    return {
      certificado: {
        senha: {
          required
        },
        arquivos: {
          minLength: minLength(1)
        }
      }
    }
  },

  components: {
    PageHeader,
    Box,
    Uploader,
    InputSenha,
    ConfirmarSenha
  }
}
</script>

<style lang="css"></style>
